import { InjectionToken } from '@angular/core';

import { AccountViewerConfig } from '../models/token';

export const ACCOUNT_VIEWER_CONFIG = new InjectionToken<AccountViewerConfig>('AccountViewerConfig');
